import { render, staticRenderFns } from "./AnketaSecurPage.vue?vue&type=template&id=157bd6ce"
import script from "./AnketaSecurPage.vue?vue&type=script&lang=js"
export * from "./AnketaSecurPage.vue?vue&type=script&lang=js"
import style0 from "./AnketaSecurPage.vue?vue&type=style&index=0&id=157bd6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports